import { useState, useEffect } from "react";

const noop = () => null;

const openSuccessCenter = () => {
  window.ChurnZero.push(["open"]);
};

export const useChurnZero = (productCode) => {
  const [hasSuccessCenter, setHasSuccessCenter] = useState(false);

  useEffect(() => {
    const czCallback = (data) => {
      setHasSuccessCenter(!!data?.hasCenter);
    };

    if (!window.ChurnZero || productCode !== "dmp") {
      return noop;
    }

    window.ChurnZero.push(["ChurnZeroEvent:on", "connected", czCallback]);

    return () =>
      window.ChurnZero.push(["ChurnZeroEvent:off", "connected", czCallback]);
  }, []);

  return {
    hasSuccessCenter,
    openSuccessCenter
  };
};
